// extracted by mini-css-extract-plugin
export default {"container":"CountriesPageTabsSkeleton_container__zKKSD","tab":"CountriesPageTabsSkeleton_tab__ANVWz","text":"CountriesPageTabsSkeleton_text__70ogY"};